export default "__VITE_ASSET__DsT9gwom__"